import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\MetricsController::__invoke
* @see app/Http/Controllers/Api/Internal/MetricsController.php:17
* @route '/internal-api/metrics'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/internal-api/metrics',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\MetricsController::__invoke
* @see app/Http/Controllers/Api/Internal/MetricsController.php:17
* @route '/internal-api/metrics'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\MetricsController::__invoke
* @see app/Http/Controllers/Api/Internal/MetricsController.php:17
* @route '/internal-api/metrics'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

const metrics = {
    store: Object.assign(store, store),
}

export default metrics